// Your business contact email, shown in the footer + contact section.
export const CONTACT_EMAIL = "support@ironroot.app";
